/*
 * Mi Reparación by RepuestosYA — centro de control de una reparación abierta.
 * Depende de RYAuto (ryauto-core.js). Ver MiCarro-PRD.md §9.
 * NO diagnostica, NO juzga precios de mano de obra, NO policía mecánicos.
 * Organiza la reparación y convierte "lo que pidió el mecánico" en links + ficha de WhatsApp.
 */
(function () {
  'use strict';

  // Diccionario de repuestos comunes (quick-add). PRD §10.5
  var COMMON_PARTS = [
    'Condensador A/C', 'Compresor A/C', 'Filtro de cabina', 'Filtro de aire', 'Filtro de aceite',
    'Filtro de combustible', 'Pastillas (balatas)', 'Discos de freno', 'Amortiguadores', 'Rótulas',
    'Terminales', 'Bomba de agua', 'Termostato', 'Radiador', 'Mangueras', 'Batería', 'Alternador',
    'Motor de arranque', 'Bujías', 'Banda / faja', 'Tensor', 'Bomba de combustible', 'Sensor',
    'Empaque', 'Retenedor', 'Rodamiento (balinera)', 'Mofle / escape', 'Embrague', 'Kit de clutch',
    'Aceite', 'Coolant'
  ];

  var STATUS_LABELS = {
    diagnostico: 'Diagnóstico', buscando: 'Buscando', comprado: 'Comprado',
    en_reparacion: 'En reparación', listo: 'Listo'
  };

  var R, el, esc;

  function boot() {
    R = window.RYAuto; el = R.ui.el; esc = R.ui.escape;
    document.querySelectorAll('[data-mi-reparacion]').forEach(mount);
  }
  if (!window.__mrSecListener) {
    window.__mrSecListener = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!window.RYAuto) return;
      (e.target || document).querySelectorAll('[data-mi-reparacion]').forEach(mount);
    });
  }

  function mount(root) {
    if (root.__mrMounted) return;
    root.__mrMounted = true;
    var app = { root: root, currentId: null };
    app.render = function () { render(app); };
    R.ui.on('repair:change', function () { if (!app.currentId) app.render(); });

    // params: ?caso=<id>  ?nuevo=1 (con draft)
    var params = new URLSearchParams(location.search);
    if (params.get('caso')) { app.currentId = params.get('caso'); }
    render(app);
    if (params.get('nuevo')) {
      var draft = consumeDraft();
      if (!draft) {
        // fallback por URL (modo privado: el draft en memoria se perdió al navegar)
        draft = {
          vehicleId: params.get('v') || '',
          title: params.get('t') || '',
          problem: params.get('p') || '',
          items: (params.get('items') || '').split('|').filter(Boolean),
          from: params.get('desde') || ''
        };
      }
      openCreate(app, draft);
    }
  }

  function consumeDraft() {
    var d = R.store.get('ryauto:v1:repairDraft');
    if (d) R.store.remove('ryauto:v1:repairDraft');
    return d;
  }

  /* ============================ render ==================================== */
  function render(app) {
    app.root.textContent = '';
    var wrap = el('div', { class: 'rya-app mr-app rya-section-pad' });
    var current = app.currentId ? R.repairs.get(app.currentId) : null;
    if (current) wrap.appendChild(renderCase(app, current));
    else wrap.appendChild(renderList(app));
    app.root.appendChild(wrap);
    try { window.scrollTo({ top: 0, behavior: 'instant' }); } catch (e) {}
  }

  /* ----------------------------------- lista ----------------------------- */
  function renderList(app) {
    var list = R.repairs.list();
    var head = el('div', { class: 'mr-head rya-stack' }, [
      el('div', { class: 'rya-eyebrow', text: R.config.storeName }),
      el('h1', { class: 'rya-h1', text: 'Mi Reparación' }),
      el('p', { class: 'rya-sub', text: 'Creá una ficha para esta reparación. Guardá lo que pidió el mecánico, fotos del repuesto y los datos de tu carro — y mandanos la ficha para ayudarte con el repuesto.' }),
      el('button', { class: 'rya-btn rya-btn--accent rya-btn--block', type: 'button', html: '<span class="rya-btn__ico">＋</span> Nueva reparación', onclick: function () { openCreate(app); } })
    ]);

    var listWrap = el('div', { class: 'rya-stack' });
    if (!list.length) {
      listWrap.appendChild(el('div', { class: 'rya-empty' }, [
        el('div', { class: 'rya-empty__ico', text: 'REP' }),
        el('p', { html: '<strong>Todavía no tenés reparaciones.</strong>' }),
        el('p', { class: 'rya-muted', text: 'Cuando tu carro entre al taller, creá una ficha aquí para no perder el control.' })
      ]));
    } else {
      list.forEach(function (c) {
        var vt = vehicleText(c);
        listWrap.appendChild(el('button', { class: 'rya-card mr-caseitem', type: 'button', onclick: function () { app.currentId = c.id; app.render(); } }, [
          el('div', { class: 'rya-between' }, [
            el('div', { class: 'rya-grow' }, [
              el('div', { class: 'rya-listitem__title', text: c.title || 'Reparación' }),
              el('div', { class: 'rya-listitem__meta', text: [vt, c.requestedItems.length + ' repuesto' + (c.requestedItems.length === 1 ? '' : 's')].filter(Boolean).join(' · ') })
            ]),
            statusBadge(c.status)
          ]),
          el('div', { class: 'rya-listitem__meta', text: 'Actualizado ' + R.ui.date(c.updatedAt) })
        ]));
      });
    }

    var foot = el('p', { class: 'rya-faint', style: { fontSize: '12px', textAlign: 'center', marginTop: '10px' }, text: 'Tus reparaciones se guardan solo en este teléfono.' });
    return el('div', { class: 'rya-stack-lg' }, [head, listWrap, foot]);
  }

  /* ----------------------------------- crear ----------------------------- */
  function openCreate(app, draft) {
    draft = draft || {};
    var vehicles = R.vehicles.list();
    var sel, snapInput;

    var vehicleField;
    if (vehicles.length) {
      sel = el('select', { class: 'rya-select' });
      vehicles.forEach(function (v) { var o = el('option', { value: v.id, text: v.nickname || R.vehicles.format(v) }); if (draft.vehicleId === v.id) o.selected = true; sel.appendChild(o); });
      sel.appendChild(el('option', { value: '__other', text: 'Otro carro (escribir)' }));
      snapInput = el('input', { class: 'rya-input', placeholder: 'Ej: Honda CR-V 2012 2.4', style: { display: 'none', marginTop: '8px' } });
      sel.addEventListener('change', function () { snapInput.style.display = sel.value === '__other' ? 'block' : 'none'; });
      vehicleField = el('div', {}, [sel, snapInput]);
    } else {
      snapInput = el('input', { class: 'rya-input', value: draft.vehicleSnapshot || '', placeholder: 'Ej: Honda CR-V 2012 2.4' });
      vehicleField = snapInput;
    }

    var title = el('input', { class: 'rya-input', value: draft.title || '', placeholder: 'Ej: Aire no enfría' });
    var problem = el('textarea', { class: 'rya-textarea', rows: '2', value: draft.problem || '', placeholder: 'Describí brevemente qué pasa.' });

    R.ui.sheet({
      title: 'Nueva reparación',
      content: [el('div', { class: 'rya-stack' }, [
        el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Tu carro' }), vehicleField]),
        el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', html: '¿Cuál es el problema? <span class="req">*</span>' }), title]),
        el('label', { class: 'rya-field' }, [el('span', { class: 'rya-field__label', text: 'Detalle (opcional)' }), problem])
      ])],
      footer: [el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Crear ficha', onclick: function (ev) {
        var t = (title.value || '').trim();
        if (!t) { title.focus(); R.ui.toast('Escribí cuál es el problema.', { type: 'warn' }); return; }
        var vehicleId = null, snapshot = '';
        if (vehicles.length && sel.value !== '__other') { vehicleId = sel.value; snapshot = R.vehicles.format(R.vehicles.get(vehicleId)); }
        else { snapshot = (snapInput.value || '').trim(); }
        var items = (draft.items || []).map(function (n) { return { id: R.util.uid('it'), name: n, query: n, note: '', bought: false }; });
        var c = R.repairs.create({ vehicleId: vehicleId, vehicleSnapshot: snapshot, title: t, problem: (problem.value || '').trim(), requestedItems: items, status: 'diagnostico' });
        R.track('rep_case_created', { from: draft.from || 'manual' });
        var root = ev.currentTarget.closest('.rya-sheet'); if (root) root.querySelector('.rya-sheet__close').click();
        app.currentId = c.id; app.render();
      } })]
    });
  }

  /* ----------------------------------- caso (centro de control) ---------- */
  function renderCase(app, c) {
    var wrap = el('div', { class: 'rya-stack-lg' });

    // header
    wrap.appendChild(el('div', { class: 'rya-stack' }, [
      el('button', { class: 'rya-link', type: 'button', text: '‹ Mis reparaciones', onclick: function () { app.currentId = null; app.render(); } }),
      el('div', { class: 'rya-between' }, [
        el('div', { class: 'rya-grow' }, [
          el('h1', { class: 'rya-h2', text: c.title || 'Reparación' }),
          el('p', { class: 'rya-muted', text: vehicleText(c) || 'Sin carro asignado' })
        ]),
        el('button', { class: 'rya-iconbtn', 'aria-label': 'Eliminar reparación', text: 'x', onclick: function () { if (confirm('¿Eliminar esta reparación?')) { R.repairs.remove(c.id); app.currentId = null; app.render(); } } })
      ])
    ]));

    // pipeline + selector de estado
    wrap.appendChild(el('div', { class: 'rya-card rya-stack' }, [
      pipeline(c.status),
      el('label', { class: 'rya-field' }, [
        el('span', { class: 'rya-field__label', text: 'Estado de la reparación' }),
        statusSelect(c, function (st) { R.repairs.setStatus(c.id, st); R.track('rep_status_change', { to: st }); app.render(); })
      ])
    ]));

    // qué pidió el mecánico
    wrap.appendChild(renderItems(app, c));

    // fotos
    wrap.appendChild(renderPhotos(app, c));

    // garantías
    wrap.appendChild(renderWarranties(app, c));

    // notas
    var notes = el('textarea', { class: 'rya-textarea', rows: '2', value: c.notes || '', placeholder: 'Notas: taller, fecha de entrega, lo que sea.' });
    notes.addEventListener('change', function () { R.repairs.update(c.id, { notes: notes.value }); });
    wrap.appendChild(el('div', { class: 'rya-card' }, [el('div', { class: 'rya-field__label', text: 'Notas' }), notes]));

    // acciones
    wrap.appendChild(renderActions(app, c));

    wrap.appendChild(el('div', { class: 'rya-alert rya-alert--info' }, [el('span', { class: 'rya-alert__ico', text: 'ℹ️' }), el('span', { text: 'Mi Reparación organiza tu reparación y la conecta con los repuestos. No hace diagnósticos ni define el precio de la mano de obra: eso lo coordinás con tu mecánico de confianza.' })]));

    return wrap;
  }

  /* --------- items que pidió el mecánico --------- */
  function renderItems(app, c) {
    var card = el('div', { class: 'rya-card rya-stack' });
    card.appendChild(el('h3', { class: 'rya-card__title', text: 'Qué pidió el mecánico' }));

    var listWrap = el('div', { class: 'rya-list' });
    card.appendChild(listWrap);
    drawItems();

    // add row con datalist
    var listId = 'mr-parts-' + c.id;
    var dl = el('datalist', { id: listId }, COMMON_PARTS.map(function (p) { return el('option', { value: p }); }));
    var input = el('input', { class: 'rya-input rya-grow', list: listId, placeholder: 'Escribí o elegí un repuesto…' });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addItem(); } });
    card.appendChild(dl);
    card.appendChild(el('div', { class: 'rya-row' }, [input, el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Agregar', onclick: addItem })]));
    return card;

    function addItem() {
      var name = (input.value || '').trim(); if (!name) { input.focus(); return; }
      c.requestedItems.push({ id: R.util.uid('it'), name: name, query: name, note: '', bought: false });
      R.repairs.update(c.id, { requestedItems: c.requestedItems });
      R.track('rep_item_added', { name: name });
      input.value = ''; input.focus(); drawItems();
    }

    function drawItems() {
      listWrap.textContent = '';
      if (!c.requestedItems.length) { listWrap.appendChild(el('p', { class: 'rya-muted', style: { fontSize: '13.5px' }, text: 'Agregá lo que el mecánico te pidió. Cada repuesto se convierte en un link para buscarlo en ' + esc(R.config.storeName) + '.' })); return; }
      c.requestedItems.forEach(function (it) {
        var v = c.vehicleId ? R.vehicles.get(c.vehicleId) : null;
        var row = el('div', { class: 'rya-listitem' + (it.bought ? ' is-bought' : '') }, [
          el('button', { class: 'mr-check' + (it.bought ? ' is-on' : ''), type: 'button', 'aria-label': 'Marcar comprado', text: it.bought ? '✓' : '', onclick: function () { it.bought = !it.bought; R.repairs.update(c.id, { requestedItems: c.requestedItems }); drawItems(); } }),
          el('div', { class: 'rya-listitem__main' }, [el('div', { class: 'rya-listitem__title', text: it.name })]),
          el('a', { class: 'rya-btn rya-btn--ghost rya-btn--sm', href: R.search.url(it.query || it.name, v), target: '_blank', rel: 'noopener', text: 'Buscar', onclick: function () { R.track('search_click', { context: 'repair_item', name: it.name }); } }),
          el('button', { class: 'rya-iconbtn', 'aria-label': 'Preguntar por WhatsApp', text: 'WA', onclick: function () { R.wa.openStore(R.wa.text(['Hola ' + R.config.storeName + ', ¿tienen este repuesto?', (vehicleText(c) ? 'Carro: ' + vehicleText(c) : ''), 'Repuesto: ' + it.name])); } }),
          el('button', { class: 'rya-iconbtn', 'aria-label': 'Quitar', text: '✕', onclick: function () { c.requestedItems = c.requestedItems.filter(function (x) { return x.id !== it.id; }); R.repairs.update(c.id, { requestedItems: c.requestedItems }); drawItems(); } })
        ]);
        listWrap.appendChild(row);
      });
    }
  }

  /* --------- fotos del repuesto viejo --------- */
  function renderPhotos(app, c) {
    c.photoIds = Array.isArray(c.photoIds) ? c.photoIds : [];
    var card = el('div', { class: 'rya-card rya-stack' }, [
      el('h3', { class: 'rya-card__title', text: 'Fotos del repuesto viejo' }),
      el('p', { class: 'rya-muted', style: { fontSize: '13px' }, text: 'Tomá o subí fotos claras del repuesto viejo, el empaque, número de parte o la pieza dañada. Quedan guardadas aquí en tu teléfono y te ayudan a pedir el repuesto correcto.' })
    ]);
    var thumbs = el('div', { class: 'rya-thumbs' });
    card.appendChild(thumbs);
    drawThumbs();

    var actions = el('div', { class: 'rya-row-wrap' }, [
      el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: '＋ Agregar foto', onclick: function () { fileInput.click(); } }),
      el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: 'Enviar fotos', onclick: shareSavedPhotos })
    ]);
    card.appendChild(actions);
    card.appendChild(el('p', { class: 'rya-faint', style: { fontSize: '12px' }, text: 'Nota: WhatsApp abre el mensaje escrito. Si tu teléfono no adjunta las fotos automáticamente, tocá el clip/cámara en WhatsApp y elegí estas fotos guardadas.' }));

    var fileInput = el('input', { type: 'file', accept: 'image/*', capture: 'environment', style: { display: 'none' }, onchange: function () {
      var file = fileInput.files && fileInput.files[0]; if (!file) return;
      R.photos.add(file).then(function (id) {
        c.photoIds.push(id); R.repairs.update(c.id, { photoIds: c.photoIds }); drawThumbs();
        R.ui.toast('Foto guardada en esta ficha.', { type: 'success' });
      }).catch(function () { R.ui.toast('No se pudo guardar la foto. Probá otra vez o tomá una foto más pequeña.', { type: 'error' }); });
      fileInput.value = '';
    }});
    card.appendChild(fileInput);
    return card;

    function drawThumbs() {
      thumbs.textContent = '';
      if (!c.photoIds.length) {
        thumbs.appendChild(el('button', { class: 'rya-thumb rya-thumb--add mr-photo-empty', type: 'button', 'aria-label': 'Agregar foto', html: '<span>Foto</span><small>Tomar foto</small>', onclick: function () { fileInput.click(); } }));
        return;
      }
      c.photoIds.forEach(function (id) {
        var img = el('img', { alt: 'Foto del repuesto' });
        R.photos.url(id).then(function (u) {
          if (!u) return;
          if (img.isConnected) img.src = u; else { try { URL.revokeObjectURL(u); } catch (e) {} }
        }).catch(function () {});
        thumbs.appendChild(el('div', { class: 'rya-thumb' }, [
          img,
          el('button', { class: 'rya-thumb__del', type: 'button', 'aria-label': 'Eliminar foto', text: '✕', onclick: function () { R.photos.remove(id); c.photoIds = c.photoIds.filter(function (x) { return x !== id; }); R.repairs.update(c.id, { photoIds: c.photoIds }); drawThumbs(); } })
        ]));
      });
      thumbs.appendChild(el('button', { class: 'rya-thumb rya-thumb--add', type: 'button', 'aria-label': 'Agregar foto', text: '＋', onclick: function () { fileInput.click(); } }));
    }

    function shareSavedPhotos() {
      if (!c.photoIds.length) { R.ui.toast('Primero agregá una foto.', { type: 'warn' }); return; }
      Promise.all(c.photoIds.map(function (id, idx) { return R.photos.file(id, 'repuesto-' + (idx + 1) + '.jpg'); }))
        .then(function (files) {
          files = files.filter(Boolean);
          if (files.length && navigator.canShare && navigator.share && navigator.canShare({ files: files })) {
            return navigator.share({
              title: 'Fotos de mi reparación',
              text: 'Fotos del repuesto viejo para mi ficha de RepuestosYA.',
              files: files
            });
          }
          R.ui.toast('Tus fotos están guardadas aquí. Adjuntalas desde WhatsApp con el clip/cámara.', { type: 'warn', duration: 5200 });
          return false;
        })
        .catch(function () {
          R.ui.toast('No se pudieron compartir automáticamente. Adjuntalas desde WhatsApp con el clip/cámara.', { type: 'warn', duration: 5200 });
        });
    }
  }

  /* --------- garantías --------- */
  function renderWarranties(app, c) {
    var card = el('div', { class: 'rya-card rya-stack' }, [el('h3', { class: 'rya-card__title', text: 'Garantías / recibos' })]);
    var listWrap = el('div', { class: 'rya-list' });
    card.appendChild(listWrap);
    draw();
    card.appendChild(el('button', { class: 'rya-btn rya-btn--ghost rya-btn--sm', type: 'button', html: '＋ Guardar garantía', onclick: openForm }));
    return card;

    function draw() {
      listWrap.textContent = '';
      if (!c.warranties.length) { listWrap.appendChild(el('p', { class: 'rya-muted', style: { fontSize: '13px' }, text: 'Guardá la garantía de los repuestos para no perderla.' })); return; }
      c.warranties.forEach(function (w) {
        listWrap.appendChild(el('div', { class: 'rya-listitem' }, [
          el('div', { class: 'rya-listitem__main' }, [el('div', { class: 'rya-listitem__title', text: w.item }), el('div', { class: 'rya-listitem__meta', text: [w.months ? w.months + ' meses' : '', w.where, w.date ? R.ui.date(w.date) : ''].filter(Boolean).join(' · ') })]),
          el('button', { class: 'rya-iconbtn', 'aria-label': 'Eliminar', text: 'x', onclick: function () { c.warranties = c.warranties.filter(function (x) { return x.id !== w.id; }); R.repairs.update(c.id, { warranties: c.warranties }); draw(); } })
        ]));
      });
    }

    function openForm() {
      var item = el('input', { class: 'rya-input', placeholder: 'Repuesto (ej. Condensador)' });
      var months = el('input', { class: 'rya-input', inputmode: 'numeric', placeholder: 'Meses' });
      var where = el('input', { class: 'rya-input', placeholder: '¿Dónde lo compraste?' });
      var date = el('input', { class: 'rya-input', type: 'date', value: new Date().toISOString().slice(0, 10) });
      R.ui.sheet({
        title: 'Guardar garantía',
        content: [el('div', { class: 'rya-stack' }, [item, el('div', { class: 'rya-grid-2' }, [months, date]), where])],
        footer: [el('button', { class: 'rya-btn rya-btn--accent', type: 'button', text: 'Guardar', onclick: function (ev) {
          if (!(item.value || '').trim()) { item.focus(); return; }
          c.warranties.push({ id: R.util.uid('war'), item: item.value.trim(), months: (months.value || '').trim(), where: (where.value || '').trim(), date: date.value });
          R.repairs.update(c.id, { warranties: c.warranties });
          var root = ev.currentTarget.closest('.rya-sheet'); if (root) root.querySelector('.rya-sheet__close').click();
          draw();
        } })]
      });
    }
  }

  /* --------- acciones --------- */
  function renderActions(app, c) {
    var msg = function () { return buildFicha(c); };
    var v = c.vehicleId ? R.vehicles.get(c.vehicleId) : null;
    var allQuery = c.requestedItems.map(function (i) { return i.name; }).join(' ');

    var card = el('div', { class: 'rya-stack' }, [
      el('button', { class: 'rya-btn rya-btn--whatsapp rya-btn--block', type: 'button', html: 'Enviar a ' + esc(R.config.storeName), onclick: function () { R.track('rep_whatsapp_send', { target: 'store' }); R.wa.openStore(msg()); } }),
      el('div', { class: 'rya-row' }, [
        el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: 'A mi mecánico', onclick: function () { sendToMechanic(msg()); } }),
        el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: 'Copiar', onclick: function () { R.clipboard.copy(msg()).then(function (ok) { R.ui.toast(ok ? 'Ficha copiada.' : 'No se pudo copiar.', { type: ok ? 'success' : 'error' }); }); } })
      ]),
      el('div', { class: 'rya-row' }, [
        c.requestedItems.length ? el('a', { class: 'rya-btn rya-btn--ghost rya-grow', href: R.search.url(allQuery, v), target: '_blank', rel: 'noopener', text: 'Buscar todos', onclick: function () { R.track('search_click', { context: 'repair_all' }); } }) : null,
        el('button', { class: 'rya-btn rya-btn--ghost rya-grow', type: 'button', text: 'Imprimir / PDF', onclick: function () { R.track('rep_print', {}); R.print.card(fichaHtml(c), { title: 'Ficha de reparación — ' + (c.title || '') }); } })
      ])
    ]);

    if (c.status === 'listo') {
      card.appendChild(el('button', { class: 'rya-btn rya-btn--accent rya-btn--block', type: 'button', html: '✓ Guardar esta reparación en Mi Carro', onclick: function () { saveToMiCarro(c); } }));
    }
    return card;
  }

  function sendToMechanic(msg) {
    var c = R.contacts.get().mechanic;
    if (c && c.phone) { R.track('rep_whatsapp_send', { target: 'mechanic' }); R.wa.open(c.phone, msg); return; }
    var name = el('input', { class: 'rya-input', placeholder: 'Nombre del mecánico (opcional)' });
    var phone = el('input', { class: 'rya-input', type: 'tel', inputmode: 'numeric', placeholder: '9999-9999' });
    R.ui.sheet({
      title: 'Número de tu mecánico',
      content: [el('p', { class: 'rya-sub', text: 'Lo guardamos en este teléfono para la próxima.' }), el('div', { class: 'rya-stack' }, [name, phone])],
      footer: [el('button', { class: 'rya-btn rya-btn--whatsapp', type: 'button', text: 'Guardar y enviar', onclick: function (ev) {
        if (!(phone.value || '').trim()) { phone.focus(); return; }
        R.contacts.set('mechanic', { name: (name.value || '').trim(), phone: phone.value.trim() });
        R.track('rep_whatsapp_send', { target: 'mechanic' }); R.wa.open(phone.value.trim(), msg);
        var root = ev.currentTarget.closest('.rya-sheet'); if (root) root.querySelector('.rya-sheet__close').click();
      } })]
    });
  }

  function buildFicha(c) {
    var lines = ['Hola ' + R.config.storeName + ', necesito ayuda con esta reparación.'];
    var vt = vehicleText(c); if (vt) lines.push('Carro: ' + vt);
    if (c.problem) lines.push('Problema: ' + c.problem);
    else if (c.title) lines.push('Problema: ' + c.title);
    if (c.requestedItems.length) {
      lines.push('El mecánico pidió:');
      c.requestedItems.forEach(function (i) { lines.push('- ' + i.name + (i.bought ? ' (comprado)' : '')); });
    }
    lines.push('Estado: ' + (STATUS_LABELS[c.status] || c.status).toLowerCase());
    if (c.photoIds.length) lines.push('Tengo ' + c.photoIds.length + ' foto' + (c.photoIds.length === 1 ? '' : 's') + ' guardada' + (c.photoIds.length === 1 ? '' : 's') + ' del repuesto viejo. La(s) adjunto en WhatsApp para que la pieza sea más fácil de confirmar.');
    return R.wa.text(lines);
  }

  function fichaHtml(c) {
    var items = c.requestedItems.length
      ? '<ul>' + c.requestedItems.map(function (i) { return '<li>' + (i.bought ? '☑' : '☐') + ' ' + esc(i.name) + '</li>'; }).join('') + '</ul>'
      : '<p class="muted">—</p>';
    var war = c.warranties.length
      ? '<ul>' + c.warranties.map(function (w) { return '<li>' + esc(w.item) + (w.months ? ' — ' + esc(w.months) + ' meses' : '') + (w.where ? ' — ' + esc(w.where) : '') + '</li>'; }).join('') + '</ul>'
      : '';
    return '<h1>' + esc(R.config.storeName) + ' — Ficha de reparación</h1>' +
      '<p class="muted">' + esc(R.ui.date(Date.now())) + '</p><hr>' +
      '<div class="row"><strong>Carro:</strong> ' + esc(vehicleText(c) || '—') + '</div>' +
      '<div class="row"><strong>Problema:</strong> ' + esc(c.title || '') + (c.problem ? ' — ' + esc(c.problem) : '') + '</div>' +
      '<div class="row"><strong>Estado:</strong> <span class="tag">' + esc(STATUS_LABELS[c.status] || c.status) + '</span></div>' +
      '<div class="row"><strong>Repuestos que pidió el mecánico:</strong></div>' + items +
      (war ? '<div class="row"><strong>Garantías:</strong></div>' + war : '') +
      (c.notes ? '<div class="row"><strong>Notas:</strong> ' + esc(c.notes) + '</div>' : '') +
      '<p class="foot">Generado en ' + esc(R.config.storeName) + ' · Mi Reparación. Esta ficha organiza los repuestos; la mano de obra se coordina con tu mecánico.</p>';
  }

  function saveToMiCarro(c) {
    var vehicleId = c.vehicleId || (R.vehicles.active() && R.vehicles.active().id);
    if (!vehicleId) { R.ui.toast('Primero creá tu carro en Mi Carro para guardar el historial.', { type: 'warn' }); return; }
    var partsTxt = c.requestedItems.map(function (i) { return i.name; }).join(', ');
    R.maintenance.add({
      vehicleId: vehicleId,
      type: c.title || 'Reparación',
      date: new Date().toISOString().slice(0, 10),
      notes: (c.problem ? c.problem + '. ' : '') + (partsTxt ? 'Repuestos: ' + partsTxt + '.' : ''),
      warranty: c.warranties[0] ? { months: c.warranties[0].months, where: c.warranties[0].where } : null
    });
    c.warranties.forEach(function (w) {
      R.parts.add({ vehicleId: vehicleId, name: w.item, query: w.item });
    });
    R.track('rep_saved_to_micarro', {});
    R.ui.toast('Guardado en el historial de Mi Carro.', { type: 'success' });
  }

  /* ============================ helpers =================================== */
  function vehicleText(c) {
    if (c.vehicleId) { var v = R.vehicles.get(c.vehicleId); if (v) return R.vehicles.format(v); }
    return c.vehicleSnapshot || '';
  }
  function statusBadge(st) {
    var cls = st === 'listo' ? 'rya-badge--done' : 'rya-badge--open';
    return el('span', { class: 'rya-badge ' + cls, text: STATUS_LABELS[st] || st });
  }
  function statusSelect(c, onChange) {
    var sel = el('select', { class: 'rya-select', onchange: function () { onChange(sel.value); } });
    R.repairs.statuses.forEach(function (s) { var o = el('option', { value: s, text: STATUS_LABELS[s] || s }); if (s === c.status) o.selected = true; sel.appendChild(o); });
    return sel;
  }
  function pipeline(current) {
    var steps = R.repairs.statuses;
    var curIdx = steps.indexOf(current);
    var wrap = el('div', { class: 'rya-steps' });
    steps.forEach(function (s, i) {
      if (i > 0) wrap.appendChild(el('span', { class: 'rya-step__bar' }));
      var cls = 'rya-step' + (i === curIdx ? ' is-active' : '') + (i < curIdx ? ' is-done' : '');
      wrap.appendChild(el('span', { class: cls }, [
        el('span', { class: 'rya-step__dot', text: i < curIdx ? '✓' : String(i + 1) }),
        el('span', { class: 'rya-step__label', text: STATUS_LABELS[s] })
      ]));
    });
    return wrap;
  }

  if (window.RYAuto) window.RYAuto.ready(boot);
  else document.addEventListener('DOMContentLoaded', function () { if (window.RYAuto) window.RYAuto.ready(boot); });
})();
